import { createWithEqualityFn } from 'zustand/traditional';

import { postPlannerQuestionerData } from '@api/educationPlanner';
import useEducationPlannerStore from '@store/EducationPlannerStore';

export interface PlannerQuestionerData {
  beginCollege: {
    year?: number;
    season?: string;
    other?: string;
  };
  currentGrade?: number;
}

export interface PlannerQuestionerStore {
  savePlannerQuestionerData: (data: PlannerQuestionerData) => Promise<void>;
  plannerQuestionerData: PlannerQuestionerData;
}

const initialState = {
  plannerQuestionerData: {
    beginCollege: {
      year: undefined,
      season: undefined,
      other: undefined,
    },
    currentGrade: undefined,
  },
};

export const usePlannerQuestionerStore = createWithEqualityFn<PlannerQuestionerStore>()(
  () => ({
    ...initialState,

    savePlannerQuestionerData: async (data: PlannerQuestionerData) => {
      try {
        const result = await postPlannerQuestionerData(data);
        useEducationPlannerStore.getState().setUserPlanning(result);
      } catch (error) {
        if (error instanceof Error) {
          throw error;
        }
        throw new Error('An unknown error occurred');
      }
    },
  }),
  Object.is,
);
